module.exports = "/static/assets/b042d172da3763f5f2a58bd8cb80dae7.gif";